/**
 * 复制到剪贴板
 * -----------------------------------------------------------------------------
 * 微信内置浏览器在 http / 老版本内核下拿不到 `navigator.clipboard`，
 * 因此保留 `execCommand('copy')` 的降级路径，并统一返回布尔值供调用方提示。
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // 非安全上下文 / 权限被拒时走下面的降级实现
  }
  try {
    const area = document.createElement('textarea');
    area.value = text;
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(area);
    return ok;
  } catch {
    return false;
  }
}
